/** 会话初始状态，应用启动时由会话恢复流程改写。 */
const initialSessionState = {
    status: 'unauthenticated',
    user: null,
    isAuthDialogOpen: false,
    authDialogView: 'login',
    isSetPasswordDialogOpen: false,
};
/** 创建打开登录弹窗的动作。 */
export function openAuthDialog() {
    return { type: 'session/openDialog' };
}
/** 创建关闭登录弹窗的动作。 */
export function closeAuthDialog() {
    return { type: 'session/closeDialog' };
}
/** 创建切换到找回密码视图的动作。 */
export function openForgotPasswordView() {
    return { type: 'session/openForgotPasswordView' };
}
/** 创建从找回密码切回登录视图的动作。 */
export function openAuthLoginView() {
    return { type: 'session/openAuthLoginView' };
}
/** 创建打开设置密码弹窗的动作。 */
export function openSetPasswordDialog() {
    return { type: 'session/openSetPasswordDialog' };
}
/** 创建关闭设置密码弹窗的动作。 */
export function closeSetPasswordDialog() {
    return { type: 'session/closeSetPasswordDialog' };
}
/** 创建登录成功动作。 */
export function loginSucceeded(user) {
    return { type: 'session/loginSucceeded', payload: user };
}
/** 创建会话失效动作。 */
export function sessionExpired() {
    return { type: 'session/sessionExpired' };
}
/** 创建登出完成动作。 */
export function logoutSucceeded() {
    return { type: 'session/logoutSucceeded' };
}
/** 创建会话恢复完成动作。 */
export function currentUserResolved(user) {
    return { type: 'session/currentUserResolved', payload: user };
}
/** 创建用户资料更新动作。 */
export function profileUpdated(user) {
    return { type: 'session/profileUpdated', payload: user };
}
/** 根据动作生成新的会话状态，保持状态转换集中且可测试。 */
export function sessionReducer(state = initialSessionState, action) {
    switch (action.type) {
        case 'session/openDialog':
            // 每次打开都从登录视图进入，避免上次停留在找回密码页造成突兀。
            return { ...state, isAuthDialogOpen: true, authDialogView: 'login' };
        case 'session/closeDialog':
            return { ...state, isAuthDialogOpen: false, authDialogView: 'login' };
        case 'session/openForgotPasswordView':
            return { ...state, isAuthDialogOpen: true, authDialogView: 'forgot' };
        case 'session/openAuthLoginView':
            return { ...state, isAuthDialogOpen: true, authDialogView: 'login' };
        case 'session/openSetPasswordDialog':
            return {
                ...state,
                isSetPasswordDialogOpen: true,
                isAuthDialogOpen: false,
                authDialogView: 'login',
            };
        case 'session/closeSetPasswordDialog':
            return { ...state, isSetPasswordDialogOpen: false };
        case 'session/loginSucceeded':
            return {
                ...state,
                status: 'authenticated',
                user: action.payload,
                isAuthDialogOpen: false,
                authDialogView: 'login',
                isSetPasswordDialogOpen: false,
            };
        case 'session/sessionExpired':
            return {
                ...state,
                status: 'unauthenticated',
                user: null,
                isAuthDialogOpen: true,
                authDialogView: 'login',
                isSetPasswordDialogOpen: false,
            };
        case 'session/logoutSucceeded':
            return {
                ...state,
                status: 'unauthenticated',
                user: null,
                isAuthDialogOpen: false,
                authDialogView: 'login',
                isSetPasswordDialogOpen: false,
            };
        case 'session/currentUserResolved':
            return {
                ...state,
                status: action.payload ? 'authenticated' : 'unauthenticated',
                user: action.payload,
            };
        case 'session/profileUpdated':
            return { ...state, status: 'authenticated', user: action.payload };
        default:
            return state;
    }
}
